import { Link, useLocation } from 'react-router-dom'

import { isFNAPath, isQuickQuotePath } from 'quick-quote/components/navigations/utils'
import { fnaPath, qqPath } from 'quick-quote/constants/path'

function FlowAwareLink(props) {
  const location = useLocation()
  const pathname = location.pathname
  const to = isFNAPath(pathname) ? fnaPath(props.to) : isQuickQuotePath(pathname) ? qqPath(props.to) : props.to

  return <Link {...props} to={to} />
}

export default FlowAwareLink
